import { AdvancedType, BasicType, BlockManager } from 'easy-email-core';
import { request } from './axios.config';
import { IEmailTemplate } from 'easy-email-editor';

export const template = {
  async getTemplate(templateName: number | string, token: string): Promise<ITemplate> {
    return request.get<ITemplate>(`/email/template/get`, {
      params: {
        templateName,
        token,
      },
    });
  },
  async updateArticle(
    templateName,
    subject,
    html,
    text,
    id,
    helperJson,
  ): Promise<ITemplate> {
    return request.post<ITemplate>('/email/template/update', {
      templateName,
      subject,
      html,
      text,
      id,
      helperJson: typeof helperJson === 'string' ? helperJson : JSON.stringify(helperJson),
    });
  },
  fetchDefaultTemplate:  () => {
    return {
      subject: 'Welcome to Easy-email',
      subTitle: 'Nice to meet you!',
      content: BlockManager.getBlockByType(BasicType.PAGE)?.create({
        // @ts-ignore: Object is possibly 'null'.
        children: [BlockManager.getBlockByType(AdvancedType.WRAPPER).create()],
      }),
    } as IEmailTemplate;
  },
  fetchDefaultTemplateOriginalData:  () => {
    return {
      subject: 'Welcome to Easy-email',
      subTitle: 'Nice to meet you!',
      content: BlockManager.getBlockByType(BasicType.PAGE)?.create({
        // @ts-ignore: Object is possibly 'null'.
        children: [BlockManager.getBlockByType(AdvancedType.WRAPPER).create()],
      }),
    } as IEmailTemplate;
  },
}
export interface ITemplate {
  templateName: string;
  subject: string;
  html: string;
  text: string;
  createdAt: string;
  updatedAt: string;
  id: number;
  helperJson: any;
}
